import { combineReducers } from 'redux'
import feature from './feature';
import station from'./station';
export default combineReducers({
	feature, station
})